import React from "react";

export const SimulatorContext = React.createContext({})
export const SimulatorPropsContext = React.createContext({})

export const CourseHistoryContext = React.createContext({})